import React from 'react';
import { type MainMenuItem, type UtilityMenuItem } from '../types';

export type CrawlerMenuItem = MainMenuItem | UtilityMenuItem;

interface CrawlerLinksProps {
    /** Main + utility menu items combined. Rendered in a hidden block for SEO/crawlers. */
    menuItems: CrawlerMenuItem[];
}

/**
 * Renders all navigation links as plain <a> in a hidden block so search engine
 * crawlers can discover and index them. The visible UI may use buttons/overlays
 * that crawlers don't follow as well.
 * */
const CrawlerLinks: React.FC<CrawlerLinksProps> = ({ menuItems }) => (
    <span aria-hidden>
        {menuItems?.map((item) => {
            const key = item.key ?? item.link?.url ?? 'item';
            return (
                <React.Fragment key={key}>
                    <a href={item.link?.url ?? '#'}>{item.link?.text ?? ''}</a>
                    {item.links?.length
                        ? item.links.map((sub) => {
                              const subKey = sub.key ?? sub.link?.url ?? 'sub';
                              return (
                                  <React.Fragment key={subKey}>
                                      <a href={sub.link?.url ?? '#'}>{sub.link?.text ?? ''}</a>
                                      {sub.links?.map((leaf) => (
                                          <a key={leaf.key ?? leaf.link?.url ?? 'leaf'} href={leaf.link?.url ?? '#'}>
                                              {leaf.link?.text ?? ''}
                                          </a>
                                      ))}
                                  </React.Fragment>
                              );
                          })
                        : null}
                </React.Fragment>
            );
        })}
    </span>
);

export default CrawlerLinks;
